import store from 'redux/store';
import UtilityActions from 'redux/utility/actions';

export const healthCheckAction = async () => {
  await store.dispatch(UtilityActions.healthCheck());
};
